import { ComponentProps, useMemo } from "react";
import { router, useNavigate } from "src/js/router/react-router";

import Feature from "src/js/stores/user/Feature";
import { Icon } from "react-migration/components/Icon";
import { Navbar } from "react-migration/domains/nav/components/Navbar";
import ROUTES from "src/js/router/routes";
import { UserMenu } from "react-migration/domains/nav/components/UserMenu";
import { isVue } from "react-migration/lib/util/isVue";
import { updateExpandedLHS } from "src/js/stores/map/actions/updateExpandedLHS";
import { updateSelection } from "src/js/stores/map/actions/updateSelection";
import { updateShowWorkbench } from "src/js/stores/map/actions/updateShowWorkbench";
import { useBetaFeatureFlag } from "react-migration/lib/user/useFeatureFlag";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const NavbarMobile = ({
  activeRoute = "",
}: ComponentProps<"div" & { activeRoute?: string | null; publicApp: boolean }>) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasProjectsBeta = useBetaFeatureFlag(Feature.projectsNavBeta);

  const mapActive = useMemo(() => {
    if (!activeRoute) return false;
    return activeRoute.includes("map") || activeRoute.includes("search") || activeRoute.includes("legacy-search");
  }, [activeRoute]);

  return (
    <Navbar.Wrapper data-testid="navbar-mobile">
      <Navbar.Item
        data-testid="navbar-map-mobile"
        active={!/\/(dashboard|sites)/.test(window.location.pathname) || !window.location.pathname}
        leadIcon={hasProjectsBeta ? "lt-navigation-3" : "lt-map-2-line"}
        onClick={() => {
          if (!mapActive) {
            isVue() ? router.push({ name: ROUTES.MAP }) : navigate(ROUTES.MAP);
          }
          updateSelection(undefined);
          updateExpandedLHS(false);
          updateShowWorkbench(false);
        }}
        mobile={true}
      >
        {t("nav.nav.map")}
      </Navbar.Item>
      <Navbar.Item
        data-testid="navbar-sites-mobile"
        active={window.location.pathname.includes("/sites")}
        leadIcon={hasProjectsBeta ? "lt-bar-graph-3" : "lt-kanban-line"}
        onClick={() => {
          isVue() ? router.push({ name: ROUTES.SITES }) : navigate(ROUTES.SITES);
        }}
        mobile={true}
      >
        {t("nav.nav.sites")}
      </Navbar.Item>

      <Navbar.Item
        data-testid="navbar-more-options-mobile"
        leadIcon="lt-more-2-line"
        mobile={true}
        mobileContextMenu={true}
        menuItem={
          <UserMenu
            triggerElement={
              <Icon
                icon="icon-lt-more-2-line"
                size="lg"
                extraClasses="text-neutral-800 block text-xl pt-2"
                cursor="pointer"
              />
            }
          />
        }
        title={t("nav.nav.more")}
      />
    </Navbar.Wrapper>
  );
};
